<template>
  <div class="header_m">
    <div class="login_topleft">
      <router-link class="btn btn_back d-flex rounded-circle border-0" to="/index">
        <i class="icon-keyboard_arrow_left" />
      </router-link>
      <div class="top_bar_lang dropdown" :class="{'show': showDropdown}" @click="showDropdown = !showDropdown">
        <a class="d-flex align-items-center dropdown-toggle" href="#">
          <span>{{ selectedLanguage }}</span>
        </a>
        <div class="dropdown-menu border-0" :class="{'show': showDropdown}" style="position: absolute; transform: translate3d(0px, 24px, 0px); top: 0px; left: 0px; will-change: transform;">
          <a v-for="(item, key) in this.$store.state.brand.info.full_language" :key="key" class="dropdown-item d-flex align-items-center" @click="changeLanguage(key)">
            <span>{{ item }}</span>
          </a>
        </div>
      </div>
    </div>
    <img class="img_logo d-flex mw-100" src="@/assets/theme4/img/fanta_game.png" height="50" alt="">
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      showDropdown: false,
      selectedLanguage: ''
    }
  },
  created() {
    let currentLangKey = ''
    if (this.$route.query.language) {
      currentLangKey = this.$route.query.language
    } else if (Cookies.get('language')) {
      currentLangKey = Cookies.get('language')
    } else {
      currentLangKey = 'zh'
    }
    for (const i in this.$store.state.brand.info.full_language) {
      if (i === currentLangKey) {
        this.selectedLanguage = this.$store.state.brand.info.full_language[i]
      }
    }
  },
  methods: {
    changeLanguage(key) {
      for (const i in this.$store.state.brand.info.full_language) {
        if (i === key) {
          this.selectedLanguage = this.$store.state.brand.info.full_language[i]
        }
      }
      var url = new URL(document.location.href)
      url.searchParams.set('language', key)
      document.location.href = url
    }
  }
}

</script>
